var map = {
	"./Exim bank.jpg": 88656,
	"./MSBank.jpg": 94395,
	"./NCBBank.jpg": 71941,
	"./OCB.jpg": 26123,
	"./SCB-Copy.jpg": 2557,
	"./vietcombank.jpg": 83060,
	"./vietinbank.png.jpg": 94021,
	"Common/Components/AppFooter/Assets/Icons/Vn/Exim bank.jpg": 88656,
	"Common/Components/AppFooter/Assets/Icons/Vn/MSBank.jpg": 94395,
	"Common/Components/AppFooter/Assets/Icons/Vn/NCBBank.jpg": 71941,
	"Common/Components/AppFooter/Assets/Icons/Vn/OCB.jpg": 26123,
	"Common/Components/AppFooter/Assets/Icons/Vn/SCB-Copy.jpg": 2557,
	"Common/Components/AppFooter/Assets/Icons/Vn/vietcombank.jpg": 83060,
	"Common/Components/AppFooter/Assets/Icons/Vn/vietinbank.png.jpg": 94021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79706;